import React, { useEffect, useMemo } from 'react'

import CustomDataTable from '../../components/CustomDataTable/CustomDataTable'
import DetailCell from './DetailCell';
import InformationBox from '../../components/InformativeBox/InformativeBox';

export const conditionalRowStyles = [
  {
    when: row => row.form_viewed === "1",
    style: {
      backgroundColor: 'rgba(127, 255, 0, 0.6)',
    },
  },
  {
    when: row => row.form_viewed === "1" && row.form_accept_reject === "2",
    style: {
      backgroundColor: 'rgba(255, 0, 0, 0.6)',
    },
  },
];

const RecordDetails = (props) => {
  const { recordDetails, endPoint } = props;
  const { testList } = recordDetails || {};
  const excludedKeys = ['id', 'updatedAt', 'deletedAt', "createdAt",];
  let recordColumn = [
    {
      name: "",
      cell: (row) => <DetailCell row={row} />
    }
  ]

  const compareValue = [
    "id",
    "patient_name",
    "patient_age",
    "patient_DOB",
    "patient_natinal_id",
    "patient_cmis_id",
    "patient_code",
    "nurses_id",
    "facility_name",
    "facility_type",
    "hospital_id",
    "hospital_Name",
    "hospital_region",
    "form_accept_reject",
    "doctore_comments1",
    "form_filling_Date",
    "form_filling_year",
    "form_code",
    "form_type",
    "form_risk_rating",
    "createdAt",
    "updatedAt",
    "deletedAt"
  ];

  const customKeyName = {
    "patient_name": "Name",
    "patient_age": "Age",
    "patient_DOB": "DOB",
    "patient_natinal_id": "National ID",
    "patient_cmis_id": "CMIS ID",
    "patient_code": "Patient Code",
    "nurses_id": "Nurse ID",
    "facility_name": "Facility Name",
    "facility_type": "Facility Type",
    "hospital_id": "Hospital ID",
    "hospital_Name": "Referred Facility",
    "hospital_region": "Hospital Region",
    "form_accept_reject": "Accept/Reject",
    "doctore_comments1": "Dr. Comment",
    "form_filling_Date": "Form Date",
    "form_filling_year": "Form Filling Year",
    "form_code": "Form Code",
    "form_type": "Form Type",
    "form_risk_rating": "Risk Rating",
  };

  testList?.values?.rows?.length && Object.keys(testList.values.rows[0]).forEach((record) => {
    if (testList.values.rows[0].hasOwnProperty(record) && (record !== "id" && record !== "deletedAt" && record !== "createdAt" && record !== "updatedAt"
      && record !== "doctore_comments1" && record !== "doctore_comments2"
      && record !== "doctore_comments3" && record !== "form_accept_reject"

      && record !== "nurses_id" && record !== "patient_DOB"
      && record !== "patient_cmis_id" && record !== "patient_code"
      && record !== "hospital_id" && record !== "hospital_region"
      && record !== "form_filling_year" && record !== "form_code"
      && record !== "nurses_region" && record !== "year"
      && record !== "facility_type" && record !== "pf_id"
      && record !== "nurse_name" && record !== "pf_id"
      && record !== "form_viewed"&& record !== "patient_gender"
      

    )) {
      const keyName = compareValue?.includes(record)
        ? customKeyName[record]
        : record.charAt(0).toUpperCase() + record.substring(1).replace(/_/g, " ");
      recordColumn.unshift({
        name: keyName,
        selector: (row) => record === "form_type" ? row["form_type"] === "2" ? "Eye Form" : "Foot Form" : row[record],

      })
    }
  })

  if (!testList) {
    return <div>Loading...</div>
  }

  return (
    <>
      {testList?.values?.rows?.length > 0 ?
        <>
          <CustomDataTable
            columns={recordColumn}
            rowData={testList.values.rows}
            tableTitle={"Test Records"}
            filterKey={"patient_name"}
            isCustom={true}
            excludedKeys={excludedKeys}
            endPoint={endPoint}
           conditionalRowStyles={conditionalRowStyles}


          />

          <InformationBox />
        </> : <h1>No Test Record Found</h1>}
    </>
  )
}

export default RecordDetails